export default "__VITE_ASSET__CGWjp3CO__"